<template>
  <figure class="image">
    <legend class="has-background-white" style="padding: 0.25rem">{{$t('Page')}} {{ number }}</legend>
    <img ref="image" :src="source" :alt="label" @load="load" :style="styles">
  </figure>
</template>

<script>
 export default {
   props: {
     number: {
       type: Number,
       required: true
     },
     source: {
       type: String,
       required: true
     },
     label: {
       type: String,
       default: ''
     }
   },
   data() {
     return {
       imageSource: null,
       width: 120,
       height: 100
     }
   },
   computed: {
     styles() {
       return {
	 display: 'inline-block',
	 width: `${this.width}px`,
	 height: `${this.height}px`,
	 backgroundColor: 'rgb(0, 0, 0, 0.075)'
       } 
     }
   },
   methods: {
     load(event) {
       this.width = event.target.naturalWidth
       this.height = event.target.naturalHeight
     }
   }
 }
</script>
